(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('KineticSearch', KineticSearch);

    KineticSearch.$inject = ['$resource'];

    function KineticSearch($resource) {
        var resourceUrl =  'api/_search/kinetics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
